export default async ({ store, route, redirect }) => {
  let { screenid, name } = route.query;
  if (screenid || name === 'auth-signin' || name === 'auth-signup' || name === '404') return;

  screenid = store.state.object.homeScreen || store.state.application.homeScreen;
  return redirect(route.path, { ...route.query, screenid });
}
